/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TimelineLite} from "gsap";
import {FITHGameConfig} from "../../FITHGameConfig";
import {FITHBigWinCountUp} from "./FITHBigWinCountUp";
import {FITHBigWinView} from "./FITHBigWinView";
import {FITHParsedGameData} from "../../server/data/FITHParsedGameData";
import {FITHGameMode} from "../../gameMode/FITHGameMode";
import {FITHGameModuleConfig} from "../../FITHGameModuleConfig";

export class FITHBigWinController extends StepCountUpBigWinController {
    private _gameView: FITHBigWinView;
    private readonly _winCountUp: FITHBigWinCountUp;
    private _playingForOutro: boolean;

    constructor(indexes: [number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall: false,
            skippableOnEachLevel: true,
        });

        const centre: number = FITHGameConfig.instance.REEL_AREA_WIDTH / 2,
            yPos: number = (centre + 200);

        this._gameView = new FITHBigWinView();
        this._winCountUp = new FITHBigWinCountUp();
        this._winCountUp.position.set(centre, yPos);
        StageManager.getLayer(FITHGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected parseFeatureGameData(data: FITHParsedGameData): void {
        let winRatios: number = data.currentBigWinWinRatio;
        if (this._gameData!.mode === FITHGameMode.NORMAL_AVALANCHE) {
            this._winLevel = -1;
        }

        if (data && data.isEndBigWin) {
            for (let i: number = this._winRatios.length - 1; i >= 0; i--) {
                if (winRatios > this._winRatios[i].ratio) {
                    this._winLevel = i;
                    return;
                }
            }
            // if the winRation is exactly 15
            this._winLevel = 0;
        } else {
            this._winLevel = -1;
        }
    }

    protected hasWin(): boolean {
        this._playingForOutro = (this._gameData !== null && this._gameData.mode === FITHGameMode.BONUS && this._gameData.nextMode === FITHGameMode.NORMAL);

        if (this._playingForOutro) {
            const isWinBelowStake: boolean = FITHGameModuleConfig.featurePrice.isWinBelowStake();
            if (this._gameData?.isBigWin) {
                this._playingForOutro = (<FITHParsedGameData>this._gameData).isEndBigWin = !isWinBelowStake;
            }
        }

        // modified for #131
        return ((this._gameData !== null) && !(<FITHParsedGameData>this._gameData).brokeTheBank && ((this._gameData.mode !== FITHGameMode.BONUS && this._gameData.singleWin === 0) || this._playingForOutro) && (<FITHParsedGameData>this._gameData).isEndBigWin && this._gameData.nextMode !== FITHGameMode.NORMAL_AVALANCHE && !(<FITHParsedGameData>this._gameData).wildTransform);
    }

    protected getBigWinLevelAnimation(level: number): Timeline {
        // #207
        if (this._playingForOutro) {
            SlotGame.keypad.setZeroBetSpinCounter(-1);
        }

        return this._gameView.getBigWinLevelAnimation(this._winRatios[level], (level + 1));
    }

    protected playBigWinCountUp(level: number, duration: number): Timeline | null {
        let totalWin: number = this._gameData!.totalWin;
        const fromValue: number = level === 0 ? 0 : this._gameData!.playedBetValue * FITHGameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue: number = level === this._winLevel ? totalWin : this._gameData!.playedBetValue * FITHGameConfig.instance.WIN_RATIOS.bigWin[level + 1].ratio;
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            this.playCountUp(fromValue, toValue, duration),
            () => {
                if (this.playBigWinCountUpSound) {
                    this.playBigWinCountUpSound(level);
                }
            }
        ]);

        return timeline;
    }

    protected playCountUp(from: number, to: number, duration: number): Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted: boolean): void {
        const totalWin: number = this._gameData!.totalWin;

        this._gameView.playEndingAnimation((this._winLevel + 1), this._playingForOutro);
        if (!this._playingForOutro) {
            SlotGame.winFieldController.showWinField(totalWin);
            FITHGameModuleConfig.waysWonGfx.abort(true, true, (this._gameData! as FITHParsedGameData).waysWonTotalRound);
        }
        this._winCountUp.abort(totalWin, isAborted);
    }

    protected isLevelWinTooSmall(level: number): boolean {
        if (level === 0) {
            return false;
        }

        const fromValue: number = this._gameData!.playedBetValue * FITHGameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue: number = this._gameData!.totalWin;

        return (toValue - fromValue) <= (fromValue * 0.1);
    }
}